import { TYPES } from "./discount.type";

const initState = {
  all: null,
};

const discountReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_DISCOUNT_SUCCESS:
      return {
        ...state,
        all: payload,
      };

    default:
      return state;
  }
};

export default discountReducer;
